// src/components/Papers/MobileFilterToggle.jsx
import React from 'react';
import { Filter, X } from 'lucide-react';

export const MobileFilterToggle = ({ isOpen, onClick, activeFiltersCount }) => {
    return (
        <button
            onClick={onClick}
            className="fixed top-20 left-4 z-30 flex items-center justify-center p-3 bg-primary-600 text-white rounded-full shadow-lg md:hidden"
        >
            {isOpen ? (
                <X className="w-5 h-5" />
            ) : (
                <div className="relative">
                    <Filter className="w-5 h-5" />
                    {activeFiltersCount > 0 && (
                        <span className="absolute -top-2 -right-2 flex items-center justify-center w-5 h-5 bg-red-500 text-white text-xs rounded-full">
                            {activeFiltersCount}
                        </span>
                    )}
                </div>
            )}
        </button>
    );
};